import { isBeforeToday } from '@components/workload/calendar/weekly/helpers';
import { parseISO } from 'date-fns';
import { ScheduleState } from './types';
import { rejectedStyles, styles } from './constants';
import { TaskColor } from '@config/colors/task';

export const getScheduleState = (startDate: string, status?: string): ScheduleState => {
  if (!status || status === 'rejected') return 'withoutTeam';
  if (isBeforeToday(parseISO(startDate))) return 'past';
  if (status === 'approved') return 'accepted';
  return 'notAccepted';
};

export const getHotSeatScheduleStyle = (
  color: string,
  foremanId?: string,
  status?: string,
): string => {
  const key = (color || 'default') as TaskColor | 'default';
  if (!foremanId) return styles[key].withoutTeam.regular;
  if (status === 'rejected') return rejectedStyles;
  if (status === 'approved') return styles[key].approved.regular;
  return styles[key].notAccepted.regular;
};
